module.exports = __webpack_public_path__ + "static/media/profilesInactive.6e2adfb1.svg";